import { render, staticRenderFns } from "./ParentLevelAccount.vue?vue&type=template&id=3875450e&scoped=true"
import script from "./ParentLevelAccount.vue?vue&type=script&lang=ts"
export * from "./ParentLevelAccount.vue?vue&type=script&lang=ts"
import style0 from "./ParentLevelAccount.vue?vue&type=style&index=0&id=3875450e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3875450e",
  null
  
)

export default component.exports